var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
		LeftRightFooter__container: true,
		'LeftRightFooter__container--padding-top': _vm.hasPaddingTop,
		'LeftRightFooter__container--padding-bottom': _vm.hasPaddingBottom,
	}},[_c('div',{staticClass:"LeftRightFooter__col"},[_vm._t("left")],2),_c('div',{staticClass:"LeftRightFooter__col"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }